export default __webpack_public_path__ + "static/media/bts-album.8a540af2.png";